import React, { useState, useEffect } from "react";
import { useParams, useLocation } from 'react-router-dom';
import { IState, ReduxMap } from "../../../redux/redux";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import { IFmsApp } from "../MobileAppTypes";
import { store } from "../../../redux/oldStore";
import { toast } from "react-toastify";
import NotificationManager from "./NotificationManager";
import BannerManager from "./BannerManager";
import Icon, { IconType } from "../../Icon/Icon";

interface IProps extends IState {

}

const TAB_ORDER = ['notifications', 'banners'];

const AppDashboard = () => {
    const { appId } = useParams<{ appId: string }>();
    const location = useLocation();
    const [app, setApp] = useState<IFmsApp | null>(null);
    const [isLoadingApp, setIsLoadingApp] = useState(true);

    const requestedTab = new URLSearchParams(location.search).get('tab');
    const initialTabIndex = Math.max(0, TAB_ORDER.indexOf(requestedTab || 'notifications'));

    useEffect(() => {
        if (appId) {
            loadAppDetails();
        }
    }, [appId]);

    const loadAppDetails = async () => {
        setIsLoadingApp(true);
        
        try {
            const response = await store.server.getApi2<IFmsApp>(`/MobileApp/AppInfo/${appId}`);
            
            if (response.Success) {
                setApp(response.Value);
            } else {
                console.error('Failed to fetch app details:', response.Message);
                toast.error(response.Message || 'Failed to fetch app details');
                setApp(null);
            }
        } catch (error) {
            console.error('Error fetching app details:', error);
            toast.error('Error fetching app details');
            setApp(null);
        } finally {
            setIsLoadingApp(false);
        }
    };

    if (isLoadingApp) {
        return (
            <div className="app-dashboard">
                <div className="app-dashboard__loading">
                    <span className="loading-spinner"></span>
                    <div style={{ marginTop: '16px' }}>Loading app details...</div>
                </div>
            </div>
        );
    }

    if (!app) {
        return (
            <div className="app-dashboard">
                <div className="app-dashboard__error">
                    <h2>App Not Found</h2>
                    <p>The requested app could not be loaded. Please check the app ID and try again.</p>
                </div>
            </div>
        );
    }

    return (
        <div className="app-dashboard">
                <h1 >{app.Name} Dashboard</h1>
            
            
                <Tabs defaultIndex={initialTabIndex}>
                    <TabList>
                        <Tab>
                            <Icon type={IconType.textMsg} />Notifications
                        </Tab>
                        <Tab>
                            <Icon type={IconType.warning} />Banners
                        </Tab>
                        {/* Future tabs can be added here */}
                    </TabList>

                    <TabPanel>
                        <NotificationManager appId={appId!} />
                    </TabPanel>
                    <TabPanel>
                        <BannerManager appId={appId!} screens={app.Screens || []} />
                    </TabPanel>
                </Tabs>
        </div>
    );
};

export default ReduxMap(AppDashboard);